import React, { useState } from 'react';
import _ from 'lodash';

import campaignModel from '../campaignModel';
import './CampaignTable.css';
import TableRow from './TableRow/TableRow';
import EditRow from './TableRow/EditRow';

const renderNoData = (noCampaign, noData, isLoading, searchQuery) => {
  if (isLoading) return <p>Loading Data...</p>;
  if (noCampaign && !isLoading)
    return (
      <>
        <i className="fal fa-search" />
        <p className="title">No Campaign Selected</p>
        <p className="description">Select a campaign to see results.</p>
      </>
    );
  if (noData && searchQuery)
    return (
      <>
        <i className="fal fa-ghost dark" />
        <p className="title">No Products Match Your Search</p>
        <p className="description">Please clear your search and try again.</p>
      </>
    );
  if (noData)
    return (
      <>
        <i className="fal fa-ghost dark" />
        <p className="title">No Products were Found</p>
        <p className="description">
          Please add products to this campaign and try again.
        </p>
      </>
    );
  return null;
};

const CampaignTable = ({
  products,
  categories,
  isLoading,
  campaignId,
  searchQuery,
  disableAdminEdit,
}) => {
  const noCampaign = !campaignId;
  const noData = _.size(products) === 0;
  const [rowsBeingEdited, setRowsBeingEdited] = useState({});
  const [imagesOpen, setImagesOpen] = useState(null);
  const renderTableBody = () => {
    if (isLoading || noCampaign || noData) {
      return (
        <tr className="no-data-container">
          <td className="no-data">
            {renderNoData(noCampaign, noData, isLoading, searchQuery)}
          </td>
        </tr>
      );
    }

    return (
      <>
        {_.map(products, (row) => {
          const rowBeingEdited = rowsBeingEdited[row.legacyPostId];
          if (rowBeingEdited) {
            return (
              <EditRow
                key={row.legacyPostId}
                row={row}
                campaignId={campaignId}
                setRowsBeingEdited={setRowsBeingEdited}
                imagesOpen={imagesOpen}
                setImagesOpen={setImagesOpen}
                categories={categories}
              />
            );
          }
          return (
            <TableRow
              key={row.legacyPostId}
              row={row}
              setRowsBeingEdited={setRowsBeingEdited}
              imagesOpen={imagesOpen}
              setImagesOpen={setImagesOpen}
              categories={categories}
              disableAdminEdit={disableAdminEdit}
            />
          );
        })}
      </>
    );
  };

  return (
    <div className="campaign-table">
      <table>
        <thead>
          <tr>
            {_.map(campaignModel, (col) => (
              <th
                key={col.key}
                style={{
                  minWidth: col.minWidth,
                }}
              >
                {col.label}
              </th>
            ))}
            <th className="actions-header">
              <span>Actions</span>
            </th>
          </tr>
        </thead>
        <tbody>{renderTableBody()}</tbody>
      </table>
    </div>
  );
};

export default CampaignTable;
